import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useRouteMatch, Route, Switch, useParams, useHistory, useLocation } from "react-router-dom";

import { authenticateMarketo, fetchMarketoForms, searchMarketoForm } from 'actions/integrations/marketo';
import { deactivateIntegration, activatingIntegrationSuccedded } from 'actions/integrations/integrations';

import cx from 'classnames';
import _ from 'lodash';
import dateformat from 'dateformat';

import {
  Row,
  Col,
  ListGroup,
  Button,
  Form,
  Image
} from "react-bootstrap";

import styles from './marketo.module.scss';

import { getBaseUrl } from 'services/util';
import { toast } from 'react-toastify';
import { SuccessToast } from 'components/Toast';

export const MarketoIntegration = () => {
  const dispatch = useDispatch();
  let { path, url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);
  const location = useLocation()
  const history = useHistory()

  const integrations = useSelector(state => _.get(state, 'integrations.activated.items', []));
  const deactivating = useSelector(state => _.get(state, 'integrations.activated.deactivating', false));
  const errors = useSelector(state => _.get(state, 'integrations.marketo.changes.error', {}));
  const saving = useSelector(state => _.get(state, 'integrations.marketo.changes.saving', false));

  let integration = (integrations || []).filter(item => {
    return item != null;
  }).find(item => {
    return item.type == 'marketo';
  });

  const [state, setState] = useState({
    clientId: _.get(integration, 'configuration.clientId', null),
    clientSecret: _.get(integration, 'configuration.clientSecret', null),
    munchkinId: null,
    syncPageViewedEvent: true,
    syncAssetViewedEvent: true,
    syncAssetDownloadEvent: true,
    syncICDownloadEvent:true,
    error: ''
  });

  useEffect(() => {
    if (integration != null) {
      setState((state) => {
        return {
          ...state,
          munchkinId: _.get(integration, 'configuration.munchkinId'),
          syncPageViewedEvent: _.get(integration, 'configuration.syncPageViewedEvent'),
          syncAssetViewedEvent: _.get(integration, 'configuration.syncAssetViewedEvent'),
          syncAssetDownloadEvent: _.get(integration, 'configuration.syncAssetDownloadEvent'),
          syncICDownloadEvent: _.get(integration, 'configuration.syncICDownloadEvent'),
        }
      })
    }
  }, [integrations]);

  const handleValueChange = (evt) => {
    setState((state) => {
      return {
        ...state,
        [evt.target.name]: evt.target.value
      }
    })
  }

  const handleSyncEvents = (event) => {
    setState((state) => {
      return {
        ...state,
        [event]: !state[event]
      }
    })
  }

  const handleSaveClick = () => {
    let request = {
      munchkinId: state.munchkinId,
      syncPageViewedEvent: state.syncPageViewedEvent,
      syncAssetViewedEvent: state.syncAssetViewedEvent,
      syncAssetDownloadEvent: state.syncAssetDownloadEvent,
      syncICDownloadEvent:state.syncICDownloadEvent
    }

    if (state.clientId) {
      request = {
        ...request,
        clientId: state.clientId
      }
    }

    if (state.clientSecret) {
      request = {
        ...request,
        clientSecret: state.clientSecret
      }
    }

    dispatch(authenticateMarketo(request, (integration) => {
      toast(
        <SuccessToast
          heading={`Success`}
          description={"Marketo Integration Updated Successfully"}
        />,
        {
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
        }
      );
      dispatch(activatingIntegrationSuccedded(integration));
    }));
  }

  const handleDeleteClick = () => {
    dispatch(deactivateIntegration('marketo', (res) => {
      handleBackClick();
    }))
  }

  const handleRestClick = () => {
    setState((state) => {
      return {
        ...state,
        clientId: null,
        clientSecret: null,
        munchkinId: _.get(integration, 'configuration.munchkinId', null),
        syncPageViewedEvent: _.get(integration, 'configuration.syncPageViewedEvent'),
        syncAssetViewedEvent: _.get(integration, 'configuration.syncAssetViewedEvent'),
        syncAssetDownloadEvent: _.get(integration, 'configuration.syncAssetDownloadEvent'),
        syncICDownloadEvent: _.get(integration, 'configuration.syncICDownloadEvent')
      }
    })
  }

  const handleBackClick = () => {
    var url = `${baseUrl}/integration-settings/integration`;
    history.push(url);
  }

  const calculatePlaceholder = (field) => {
    var placeholder = field === 'clientId' ? 'Enter your Client Id' : 'Enter your Client Secret';
    return integration ? `*************** last updated: ${dateformat(integration.createdDate, 'dd mmm yyyy')}` : placeholder;
  }

  const integrationData = location.state

  return (
    <div className={styles.marketoContent}>
      <Button variant='light' onClick={handleBackClick} className={styles.backButton} >
        <i className="cleverstory-left" />
        Back
      </Button>
      <div className={styles.formContainer}>
        <Row className={styles.cardWrapper}>
          <Col className={styles.integrationDetail} md={5}>
            <div className={styles.logoContainer}>
              <Image src={integrationData.logo} />
            </div>
            <div className={styles.detailContainer}>
              <span className={styles.title}>{integrationData.title}</span>
              <span className={styles.description}>{integrationData.description}</span>
              {integration && <Button variant='secondary' onClick={handleDeleteClick} className={styles.deactivateButton} >{deactivating ? 'Deactivating...' : 'Deactivate'}</Button>}
              {!integration && <span className={styles.inactiveStatus}>INACTIVE</span>}
            </div>
          </Col>
          <Col className={styles.authForm} md={7}>
            <div className={styles.marketoAuthentication}>
              <div className={styles.formWrapper}>
                <Form.Group className="mb-3" controlId="id">
                  <Form.Label className={styles.inputLabel}>Munchkin-ID</Form.Label>
                  <Form.Control className={styles.inputField} value={state.munchkinId} onChange={handleValueChange} name="munchkinId" type="text" placeholder="Enter Munchkin id" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="clientId">
                  <Form.Label className={styles.inputLabel}>Client-ID</Form.Label>
                  <Form.Control className={styles.inputField} value={state.clientId} placeholder={calculatePlaceholder('clientId')} onChange={handleValueChange} name="clientId" type="text" />
                </Form.Group>
                <Form.Group className="mb-3" controlId="ClientSecret">
                  <Form.Label className={styles.inputLabel}>Client Secret</Form.Label>
                  <Form.Control className={styles.inputField} value={state.clientSecret} placeholder={calculatePlaceholder('clientSecret')} onChange={handleValueChange} name="clientSecret" type="text" />
                </Form.Group>
              </div>
              <div className={styles.syncEvents}>
                <span className={styles.inputLabel}>Sync Event</span>
                <div className={styles.toggleSwitchContainer}>
                  <span className={cx(styles.content, {[styles.active]: state.syncPageViewedEvent})}>Contact/Lead visits a page</span>
                  <Form.Check
                    type="switch"
                    checked={state.syncPageViewedEvent}
                    onChange={() => handleSyncEvents('syncPageViewedEvent')}
                    className={styles.toggleSwitch}
                    id="lead-visits"
                  />
                </div>

                <div className={styles.toggleSwitchContainer}>
                  <span className={cx(styles.content, {[styles.active]: state.syncAssetViewedEvent})}>Contact/Lead views an asset</span>
                  <Form.Check
                    type="switch"
                    checked={state.syncAssetViewedEvent}
                    onChange={() => handleSyncEvents('syncAssetViewedEvent')}
                    className={styles.toggleSwitch}
                    id="lead-views"
                  />
                </div>
                <div className={styles.toggleSwitchContainer}>
                  <span className={cx(styles.content, {[styles.active]: state.syncAssetDownloadEvent})}>Contact/Lead download an asset</span>
                  <Form.Check
                    type="switch"
                    onChange={() => handleSyncEvents('syncAssetDownloadEvent')}
                    checked={state.syncAssetDownloadEvent}
                    className={styles.toggleSwitch}
                    id="lead-downloads"
                  />
                </div>
                <div className={styles.toggleSwitchContainer}>
                  <span className={cx(styles.content, {[styles.active]: state.syncICDownloadEvent})}>Contact/Lead download an Interactive Content</span>
                  <Form.Check
                    type="switch"
                    onChange={() => handleSyncEvents('syncICDownloadEvent')}
                    checked={state.syncICDownloadEvent}
                    className={styles.toggleSwitch}
                    id="lead-downloads"
                  />
                </div>

              </div>
            </div>
          </Col>
        </Row>
      </div>
      <div className={styles.actionContainer}>
        <Button variant='secondary' onClick={handleRestClick} className={styles.resetButton}>Reset</Button>
        <Button variant='primary' onClick={handleSaveClick} className={styles.saveButton}>{saving ? 'Saving...' : 'Save Changes'}</Button>
      </div>
    </div>
  )
}
